import { memo } from 'react';

import { AtSignIcon } from '@air/design-icons';

import { UploadZoneOverlay } from '~/components/PrivateDropzone/components/UploadZoneOverlay';

export type PrivateWorkspaceAgentPanelSelectionDropOverlayProps = {
  description: string;
  isDragOver: boolean;
};

const SELECTION_DROP_TITLE = 'Drop to add to your message';

export const PrivateWorkspaceAgentPanelSelectionDropOverlay = memo(
  ({ description, isDragOver }: PrivateWorkspaceAgentPanelSelectionDropOverlayProps) => {
    if (!isDragOver) {
      return null;
    }

    return (
      <div className="pointer-events-none absolute inset-0 z-10">
        <div aria-hidden className="absolute inset-0 ads:bg-base bg-gray-1" />
        <UploadZoneOverlay
          aria-hidden
          className="absolute inset-2.5 z-1 px-4 py-8 ads:text-primary text-gray-12"
          data-testid="WORKSPACE_AGENT_PANEL_SELECTION_DROP_OVERLAY"
          description={description}
          icon={AtSignIcon}
          isActive={isDragOver}
          title={SELECTION_DROP_TITLE}
        />
      </div>
    );
  },
);

PrivateWorkspaceAgentPanelSelectionDropOverlay.displayName = 'PrivateWorkspaceAgentPanelSelectionDropOverlay';
